// import { withStyles } from '@material-ui/core/styles'
import withStyles from 'react-jss'
import styles from './styles'

import Printer from './SalesOrderPrinter'

export default withStyles(styles)(Printer)
